// extracted by mini-css-extract-plugin
export default {"root":"TextArea_root__Die1i","label":"TextArea_label__0IdJi","errorMessage":"TextArea_errorMessage__YQJTL"};